import { FC, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import styled from "styled-components";

interface Props {
  type?: string;
  minValue: number;
  maxValue: number;
  wholeNumbers?: boolean;
  value: number;
  setValue: (value: number) => void;
  setIsInvalid?: (invalid: boolean) => void;
}

export const MABNumberInput: FC<Props> = ({
  type = "text",
  minValue,
  maxValue,
  value,
  wholeNumbers = true,
  setValue,
  setIsInvalid,
}) => {
  const [internalValue, setInternalValue] = useState<number>(value);

  const isNumber = !isNaN(Number(internalValue));
  const isInvalid =
    !isNumber ||
    (Boolean(maxValue) && Number(internalValue) > maxValue!) ||
    (Boolean(minValue) && Number(internalValue) < minValue!) ||
    (wholeNumbers && !Number.isInteger(Number(internalValue)));

  useEffect(() => {
    if (setIsInvalid) {
      setIsInvalid(isInvalid);
    }
  }, [internalValue]);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  return (
    <OuterContainer>
      <TextForm
        type={type}
        value={internalValue}
        onChange={(e: React.ChangeEvent<any>) => {
          const inputValue = e.target.value;
          if (+inputValue <= maxValue) {
            setValue(inputValue);
            setInternalValue(inputValue);
          }
        }}
        isInvalid={isInvalid}
        max={maxValue}
      />
    </OuterContainer>
  );
};

const OuterContainer = styled.div.attrs({ className: "no-drag" })`
  width: 15cqw;
`;

const TextForm = styled(Form.Control)`
  border: 2px solid var(--secondary);

  /* Remove arrows for type="number" inputs */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  & {
    -moz-appearance: textfield;
  }
`;
